import React, { useState } from "react";
import whatsappLogo from "../images/whatsapp-icon.svg";
import {
  FiMail,
  FiPhone,
  FiMapPin,
  FiClock,
  FiSend,
  FiCheckCircle,
  FiMessageCircle,
  FiFacebook,
  FiInstagram,
} from "react-icons/fi";
import "./Contact.css";
import emailjs from "@emailjs/browser";

const HERO_IMG =
  "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1920&q=80";
const FB = "https://www.facebook.com/share/1aF6XPZiM4/";
const INSTA =
  "https://www.instagram.com/shaheeninternationalsports16?igsh=MWdmNG5lb2RieDFoMw==";

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    product: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = "Full name is required.";
    if (!form.email.trim() || !/\S+@\S+\.\S+/.test(form.email))
      e.email = "A valid email is required.";
    if (!form.message.trim()) e.message = "Please describe your requirement.";
    return e;
  };

  const handleSubmit = (ev) => {
    ev.preventDefault();

    const e = validate();
    if (Object.keys(e).length) {
      setErrors(e);
      return;
    }

    // 👉 FAKE API CALL (simulate delay)
    console.log("Form submitted ", form);

    setTimeout(() => {
      setSubmitted(true);
      alert("Message sent successfully (dummy mode)!");
    }, 1000);
  };

  const handleChange = (ev) => {
    const { name, value } = ev.target;
    setForm((p) => ({ ...p, [name]: value }));
    setErrors((p) => ({ ...p, [name]: "" }));
  };

  const waMsg = encodeURIComponent(
    "Hi Shaheen Sports! I want to make an inquiry about your products.",
  );

  return (
    <div className="contact-page">
      {/* Hero */}
      <section className="contact-hero">
        <div
          className="contact-hero__img"
          style={{ backgroundImage: `url(${HERO_IMG})` }}
        />
        <div className="contact-hero__overlay" />
        <div className="container contact-hero__content">
          <span className="section-label">Get In Touch</span>
          <h1 className="contact-hero__title">
            Contact <span>Shaheen Sports</span>
          </h1>
          <p className="contact-hero__sub">
            Product inquiry, custom order or partnership proposal? We respond
            within 24 business hours.
          </p>
          <div className="contact-hero__options">
            <a
              href={`https://wa.me/923420757213?text=${waMsg}`}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-hero__opt contact-hero__opt--wa"
            >
              <FiMessageCircle size={18} /> WhatsApp Us
            </a>
            <a
              href="mailto:ShaheenInternationalSports1@gmail.com"
              className="contact-hero__opt contact-hero__opt--email"
            >
              <FiMail size={18} /> Email Us
            </a>
            <a
              href={FB}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-hero__opt contact-hero__opt--fb"
            >
              <FiFacebook size={18} /> Facebook
            </a>
            <a
              href={INSTA}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-hero__opt contact-hero__opt--ig"
            >
              <FiInstagram size={18} /> Instagram
            </a>
          </div>
        </div>
        <div className="contact-hero__shape" />
      </section>

      {/* Contact Layout */}
      <section className="contact-section">
        <div className="container contact-layout">
          {/* Info */}
          <div className="contact-info">
            <h2>Our Contact Details</h2>
            <div className="divider-gold" />
            <p className="contact-info__intro">
              We welcome inquiries from academies, retail brands, distributors
              and national sports federations worldwide.
            </p>

            <div className="contact-detail">
              <div className="contact-detail__icon">
                <FiPhone size={20} />
              </div>
              <div>
                <strong>Phone / WhatsApp</strong>
                <a href="tel:+923420757213">+92-342-075 7213</a>
              </div>
            </div>

            <div className="contact-detail">
              <div className="contact-detail__icon">
                <FiMail size={20} />
              </div>
              <div>
                <strong>Email</strong>
                <a href="mailto:ShaheenInternationalSports1@gmail.com">
                  ShaheenInternationalSports1@gmail.com
                </a>
              </div>
            </div>

            <div className="contact-detail">
              <div className="contact-detail__icon">
                <FiClock size={20} />
              </div>
              <div>
                <strong>Business Hours</strong>
                <span>Mon – Sat: 9:00 AM – 6:00 PM (PKT)</span>
                <span>Sunday: Closed</span>
              </div>
            </div>

            {/* WhatsApp */}
            <div className="contact-wa-option">
              <div className="contact-wa-option__icon">
                <img
                  src={whatsappLogo}
                  alt="WhatsApp"
                  className="wa-logo-img"
                />
              </div>
              <div>
                <strong>Prefer WhatsApp?</strong>
                <span>Chat directly with our sales team</span>
                <a
                  href={`https://wa.me/923420757213?text=${waMsg}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FiMessageCircle size={13} /> Start WhatsApp Chat →
                </a>
              </div>
            </div>

            {/* Social Buttons */}
            <div className="contact-social-btns">
              <p className="contact-social-btns__label">
                Follow Us On Social Media
              </p>
              <div className="contact-social-btns__row">
                <a
                  href={FB}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-social-btn contact-social-btn--fb"
                >
                  <FiFacebook size={18} /> Facebook
                </a>
                <a
                  href={INSTA}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-social-btn contact-social-btn--ig"
                >
                  <FiInstagram size={18} /> Instagram
                </a>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="contact-form-wrap">
            {submitted ? (
              <div className="form-success">
                <FiCheckCircle size={52} color="var(--gold)" />
                <h3>Message Received!</h3>
                <p>Our team will respond within 24 business hours.</p>
                <button
                  className="btn-dark"
                  onClick={() => {
                    setSubmitted(false);
                    setForm({
                      name: "",
                      company: "",
                      email: "",
                      phone: "",
                      product: "",
                      message: "",
                    });
                  }}
                >
                  Send Another
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} noValidate>
                <h3 className="form-title">Send an Inquiry</h3>
                <p className="form-subtitle">
                  Fields marked <span>*</span> are required.
                </p>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">
                      Full Name <span>*</span>
                    </label>
                    <input
                      id="name"
                      name="name"
                      type="text"
                      placeholder="Your full name"
                      value={form.name}
                      onChange={handleChange}
                      className={errors.name ? "input-error" : ""}
                    />
                    {errors.name && (
                      <span className="field-error">{errors.name}</span>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="company">Company / Academy</label>
                    <input
                      id="company"
                      name="company"
                      type="text"
                      placeholder="Your company"
                      value={form.company}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="email">
                      Email <span>*</span>
                    </label>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      placeholder="your@email.com"
                      value={form.email}
                      onChange={handleChange}
                      className={errors.email ? "input-error" : ""}
                    />
                    {errors.email && (
                      <span className="field-error">{errors.email}</span>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone">Phone / WhatsApp</label>
                    <input
                      id="phone"
                      name="phone"
                      type="tel"
                      placeholder="+92-342-075 7213"
                      value={form.phone}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="product">Product of Interest</label>
                  <select
                    id="product"
                    name="product"
                    value={form.product}
                    onChange={handleChange}
                  >
                    <option value="">Select a product</option>
                    <option>Judo Gi</option>
                    <option>Jiujitsu Gi</option>
                    <option>MMA Shorts</option>
                    <option>Rash Guards</option>
                    <option>Spats</option>
                    <option>Sports Bra</option>
                    <option>Belts</option>
                    <option>Keychains</option>
                    <option>Separate Patches</option>
                    <option>Custom / Other</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message">
                    Requirements <span>*</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows="5"
                    placeholder="Quantity, sizes, custom branding, delivery timeline..."
                    value={form.message}
                    onChange={handleChange}
                    className={errors.message ? "input-error" : ""}
                  />
                  {errors.message && (
                    <span className="field-error">{errors.message}</span>
                  )}
                </div>

                <button type="submit" className="btn-primary form-submit">
                  Send Message <FiSend size={16} />
                </button>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* Map */}
    </div>
  );
}
